import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContacts = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8025 15.7583L14.5109 15.0258C14.3634 14.6541 14.1342 14.3208 13.8409 14.0491L13.7875 14C13.3259 13.5716 12.7192 13.3333 12.0892 13.3333H7.91085C7.28085 13.3333 6.67419 13.5716 6.21169 13.9991L6.15835 14.0491C5.86502 14.3208 5.63669 14.6541 5.48835 15.0258L5.19669 15.7583",
			stroke: "#748094",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0624 6.20596C13.2015 7.34499 13.2015 9.19172 12.0624 10.3308C10.9234 11.4698 9.07668 11.4698 7.93765 10.3308C6.79862 9.19172 6.79862 7.34499 7.93765 6.20596C9.07668 5.06693 10.9234 5.06693 12.0624 6.20596",
			stroke: "#748094",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3033 4.6967C18.2323 7.62563 18.2323 12.3744 15.3033 15.3033C12.3744 18.2322 7.62568 18.2322 4.69676 15.3033C1.76783 12.3744 1.76783 7.62562 4.69676 4.6967C7.62569 1.76777 12.3744 1.76777 15.3033 4.6967",
			stroke: "#748094",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgContacts;
